// extracted by mini-css-extract-plugin
export var acceptButton = "_3w-5";
export var fullContent = "_3w-4";
export var link = "_3w-6";
export var linkIcon = "_3w-7";
export var sideContent = "_3w-3";
export var sideImage = "_3w-2";
export var sideImageWrapper = "_3w-1";
export var splitLayout = "_3w-0";